import { ExportOutlined, LeftOutlined } from "@ant-design/icons";
import { Drawer, Menu, Select, Tooltip } from "antd";
import { BsArrowClockwise } from "react-icons/bs";
import { GoSearch } from "react-icons/go";
import { IoPersonAddOutline } from "react-icons/io5";
import { LuForward } from "react-icons/lu";
import { MdDeleteOutline, MdLabelOutline } from "react-icons/md";
import { VscLayoutSidebarRight } from "react-icons/vsc";
import { conversationType, PANEL_STATUS } from "../../config/Constant";
import { useMailContext } from "../../context/MailContext";
import { useMenuContext } from "../../context/MenuContext";
import { useInfoUser } from "../../store/UserStore";
import "./style.scss";

const SideBarMail = ({
  isOpen,
  onClose,
  onForwardAll,
  onRefresh,
  onToggleGroupInfo,
  onDelete,
}) => {
  const { labelList } = useMenuContext();
  const { languageMap } = useInfoUser();
  const {
    selectedConversation,
    onSearch,
    onChangeLabel,
    refreshMailMessage,
    openAddMemberModal,
    setIsMenu,
    showModalLabel,
    labelSelectedId,
    showModalAddCC,
    setPanelStatus,
  } = useMenuContext();

  const mailCtx = useMailContext?.() || {};
  const { setIsOpenModalDeleteConversation, setIsForwardAllMail } = mailCtx;

  const runAction = (action) => {
    onClose?.();
    action?.();
  };

  const handleToggleGroupInfo = () => {
    if (onToggleGroupInfo) {
      onToggleGroupInfo();
      return;
    }
    setPanelStatus?.((prev) => {
      if (
        [PANEL_STATUS.GROUP_INFO, PANEL_STATUS.MEDIA_STORAGE].includes(prev)
      )
        return null;
      return PANEL_STATUS.GROUP_INFO;
    });
  };

  return (
    <Drawer
      placement={"right"}
      closable={false}
      onClose={onClose}
      open={isOpen}
      width={330}
      className="drawer-visible"
      title={
        <div className="flex flex-row">
          <span className="drawer-label">
            <a
              onClick={() => {
                setIsMenu(false);
              }}
            >
              <LeftOutlined className="drawer-btn-close" />
            </a>
            {languageMap?.["modal.menu"] ?? "Menu"}
          </span>
        </div>
      }
    >
      <Menu
        mode="inline"
        width={330}
        selectable={false}
        className="py-4 overflow-y-auto space-y-2 font-medium"
      >
        {!selectedConversation ||
          selectedConversation?.type === conversationType.DRAFT ? (
          <>
            <Menu.Item
              key="addMember"
              className="cursor-pointer"
              onClick={() => runAction(openAddMemberModal)}
            >
              <div className="drawer-item">
                <div className="drawer-item-icon">
                  <IoPersonAddOutline size={20} color="black" />
                </div>
                <div className="ms-3">
                  <span>
                    {languageMap?.["modal.notification.sendTo"] ??
                      "Send to members"}
                  </span>
                </div>
              </div>
            </Menu.Item>

            <Menu.Item
              key="cc"
              className="cursor-pointer"
              onClick={() => runAction(showModalAddCC)}
            >
              <div className="drawer-item">
                <div className="drawer-item-icon flex items-center">
                  <span className="icon text-black text-[18px] icon font-normal">
                    Cc
                  </span>
                </div>
                <div className="ms-3">
                  <span>{languageMap?.["modal.notification.cc"] ?? "Cc"}</span>
                </div>
              </div>
            </Menu.Item>
          </>
        ) : (
          <>

            <Menu.Item
              key="forwardAll"
              className="cursor-pointer"
              onClick={() =>
                runAction(() => {
                  if (onForwardAll) onForwardAll();
                  else setIsForwardAllMail?.(true);
                })
              }
            >
              <div className="drawer-item">
                <div className="drawer-item-icon">
                  <LuForward size={20} color="black" />
                </div>
                <div className="ms-3">
                  <span>
                    {languageMap?.["modal.notification.forwardAll"] ??
                      "Forward all messages"}
                  </span>
                </div>
              </div>
            </Menu.Item>

            <Menu.Item
              key="search"
              className="cursor-pointer"
              onClick={() => runAction(onSearch)}
            >
              <div className="drawer-item">
                <div className="drawer-item-icon">
                  <GoSearch size={20} color="black" />
                </div>
                <div className="ms-3">
                  <span>
                    {languageMap?.["menu.conversation.searchMessage"] ??
                      "Search messages"}
                  </span>
                </div>
              </div>
            </Menu.Item>

            <Menu.Item
              key="refresh"
              className="cursor-pointer"
              onClick={() =>
                runAction(() => {
                  if (onRefresh) onRefresh();
                  else refreshMailMessage?.();
                })
              }
            >
              <div className="drawer-item">
                <div className="drawer-item-icon">
                  <BsArrowClockwise size={20} color="black" />
                </div>
                <div className="ms-3">
                  <span>
                    {languageMap?.["menu.conversation.refresh"] ?? "Refresh"}
                  </span>
                </div>
              </div>
            </Menu.Item>

            <Menu.Item
              key="groupInfo"
              className="cursor-pointer"
              onClick={() => runAction(handleToggleGroupInfo)}
            >
              <div className="drawer-item">
                <div className="drawer-item-icon">
                  <VscLayoutSidebarRight size={20} color="black" />
                </div>
                <div className="ms-3">
                  <span>
                    {languageMap?.["menu.conversation.groupInfo"] ??
                      "Group information"}
                  </span>
                </div>
              </div>
            </Menu.Item>
          </>
        )}
      </Menu>
    </Drawer>
  );
};

export { SideBarMail };
